import inspectionService from '@Apis/inspection.api';
import { InspectionStandardCodeSet } from '@Types/inspections.types';

export const fetchInspectionsOverview = async () => {
	try {
		const { data } = await inspectionService.get('/inspections', {
			params: { overview: true },
		});
		return data;
	} catch (error) {
		console.error('Failed to fetch inspections overview:', error);
		throw error;
	}
};

export const fetchInspectionStandardCodesAPI = async (standard: string): Promise<InspectionStandardCodeSet> => {
	const response = await inspectionService.get(`
				codes/${encodeURIComponent(standard)}`);
	return response.data;
};
